// extracted by mini-css-extract-plugin
module.exports = {"container":"ZeyEQ","dot":"_3Ljp2","opacitychange":"_2wWcl"};